// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RunQuarantinedRecord } from './run-quarantined-record';
import {
    RunQuarantinedRecordFromJSON,
    RunQuarantinedRecordFromJSONTyped,
    RunQuarantinedRecordToJSON,
    RunQuarantinedRecordToJSONTyped,
} from './run-quarantined-record';
import type { RunModifiedRecord } from './run-modified-record';
import {
    RunModifiedRecordFromJSON,
    RunModifiedRecordFromJSONTyped,
    RunModifiedRecordToJSON,
    RunModifiedRecordToJSONTyped,
} from './run-modified-record';

/**
 * 
 * @export
 * @interface GetRunChangesResponseContent
 */
export interface GetRunChangesResponseContent {
    /**
     * 
     * @type {Array<RunModifiedRecord>}
     * @memberof GetRunChangesResponseContent
     */
    modified: Array<RunModifiedRecord>;
    /**
     * 
     * @type {Array<RunQuarantinedRecord>}
     * @memberof GetRunChangesResponseContent
     */
    quarantined: Array<RunQuarantinedRecord>;
}

/**
 * Check if a given object implements the GetRunChangesResponseContent interface.
 */
export function instanceOfGetRunChangesResponseContent(value: object): value is GetRunChangesResponseContent {
    if (!('modified' in value) || value['modified'] === undefined) return false;
    if (!('quarantined' in value) || value['quarantined'] === undefined) return false;
    return true;
}

export function GetRunChangesResponseContentFromJSON(json: any): GetRunChangesResponseContent {
    return GetRunChangesResponseContentFromJSONTyped(json, false);
}

export function GetRunChangesResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetRunChangesResponseContent {
    if (json == null) {
        return json;
    }
    return {
        
        'modified': ((json['modified'] as Array<any>).map(RunModifiedRecordFromJSON)),
        'quarantined': ((json['quarantined'] as Array<any>).map(RunQuarantinedRecordFromJSON)),
    };
}

export function GetRunChangesResponseContentToJSON(json: any): GetRunChangesResponseContent {
    return GetRunChangesResponseContentToJSONTyped(json, false);
}

export function GetRunChangesResponseContentToJSONTyped(value?: GetRunChangesResponseContent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'modified': ((value['modified'] as Array<any>).map(RunModifiedRecordToJSON)),
        'quarantined': ((value['quarantined'] as Array<any>).map(RunQuarantinedRecordToJSON)),
    };
}
